export default __webpack_public_path__ + "static/media/chai.5b17f2a0.jpeg";